import { runtimeConfig } from '@/shared/config'

// Вход в экосистему — единая страница хаба (22-unified-login): сотрудник уходит
// с неё в Authentik, заказчик вводит логин и пароль. Своей формы входа у deal
// нет ни для кого; фронт только уводит туда и возвращается по ?rd=.
//
// Выход разведён по контурам: сотрудника гасит employee-backend (id.stit.tech),
// заказчика — company-backend (shared/api/client.ts, logoutCustomerSession).

// Пропускаем только внутренний absolute-path ("/boards"): не "//evil"
// (protocol-relative), не "\..\", без CRLF — защита от open-redirect. Зеркалит
// sanitizeReturnTo BFF — двойная страховка, бэк санитайзит повторно.
export function sanitizeInternalPath(raw: string | null | undefined): string | undefined {
  if (raw?.[0] !== '/' || raw.startsWith('//') || /[\\\r\n]/.test(raw)) return undefined
  return raw
}

// expired — сессию не удалось продлить, signedout — вышли сами. Страница входа
// показывает по нему свою плашку.
export type LoginNotice = 'expired' | 'signedout'

export function loginUrl(returnTo: string = window.location.href, notice?: LoginNotice): string {
  const params = new URLSearchParams({ rd: returnTo })
  if (notice) params.set('notice', notice)
  return `${runtimeConfig.HUB_LOGIN_URL}?${params.toString()}`
}

// Реальная браузерная навигация (не router-redirect): уходим на чужой origin.
export function redirectToLogin(
  returnTo: string = window.location.href,
  notice?: LoginNotice,
): void {
  window.location.assign(loginUrl(returnTo, notice))
}

// Выход сотрудника — через его BFF: id.stit.tech/auth/logout гасит hub-сессию,
// ставит tombstone и чистит cookie (Domain=.stit.tech). Метод — POST: BFF
// принимает logout только POST (GET → 405), и logout-by-GET уязвим к
// link-prefetch (браузер разлогинил бы без клика). POST-навигацию к чужому
// origin даёт скрытая авто-сабмит форма — hub гасит сессию и 302-редиректит по ?rd=.
export function redirectToEmployeeLogout(returnTo: string = window.location.origin): void {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = `${runtimeConfig.ID_BASE_URL}/auth/logout?rd=${encodeURIComponent(returnTo)}`
  document.body.appendChild(form)
  form.submit()
}
